module.exports = __webpack_public_path__ + "static/media/time_black.2e75fb30.svg";